import { render, staticRenderFns } from "./quesSuccess3.vue?vue&type=template&id=65266f6e"
import script from "./quesSuccess3.vue?vue&type=script&lang=js"
export * from "./quesSuccess3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports